/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Features_PaidInputs */

const en_features_paid = /** @type {(inputs: Features_PaidInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} paid online`)
};

const pl_features_paid = /** @type {(inputs: Features_PaidInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} zapłaciła online`)
};

/**
* | output |
* | --- |
* | "{name} paid online" |
*
* @param {Features_PaidInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const features_paid = /** @type {((inputs: Features_PaidInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_PaidInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_features_paid(inputs)
	return en_features_paid(inputs)
});